import { HttpClient, HttpHeaders } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { BehaviorSubject, map, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { LoginModel } from "../../models/login/login.model";
import { HttpService } from "../common/http-service";
import { SignupModel } from "../../models/signup/signup.model";
import { UserModel } from "../../models/user/user.model";
import { ResetPasswordModel } from "../../models/reset-password/reset-password.model";
import { ForgotPasswordModel } from "../../models/forgot-password/forgot-password.model";
import { EditProfileModel } from "../../../pos-panel/models/edit-profile/edit-profile.model";
import { RoleNameEnum } from "../../../admin-panel/enums/role-name.enum";
import { ChangePasswordModel } from "../../models/change-password/change-password.model";
import { RefreshTokenModel } from "../../models/refresh-token/refresh-token.model";
import { WaiterLoginModel } from "../../models/login/waiter-login.model";
import { WaiterHttpService } from "../common/waiter-http-service";
import { SignoutModel } from "../../models/signout/signout.model";
import { MenuService, VenueService } from "src/api/generated/services";

const AUTH_API = environment.apiURL + '/api/pos/User/';
const GMN_USER_API = environment.apiURL + '/api/gmn/User/';
const MNG_USER_API = environment.apiURL + '/api/mng/User/';
const WTR_USER_API = environment.apiURL + '/api/wtr/User/';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  _isLoggedIn$ = new BehaviorSubject<boolean>(false);
  _isAdmin$ = new BehaviorSubject<boolean>(false);
  _isManager$ = new BehaviorSubject<boolean>(false);

  private readonly access_token = 'pos_access_token';
  private readonly waiter_access_token = 'waiter_access_token';
  private readonly waiter_refresh_token = 'waiter_refresh_token';
  
  loginUser = new BehaviorSubject<UserModel | null>(null);

  public isLoggedIn$ = this._isLoggedIn$.asObservable();
  public isManager$ = this._isManager$.asObservable();

  get token(): any {
    return localStorage.getItem(this.access_token);
  }
  get waiterToken(): any {
    return localStorage.getItem(this.waiter_access_token);
  }

  constructor(private _httpService: HttpService,
              private _waiterHttpService: WaiterHttpService,
              private _httpClient: HttpClient,
              private _jwtHelperService: JwtHelperService) {
    if (this.token && !_jwtHelperService.isTokenExpired(this.token)) {    
      this._isLoggedIn$.next(!!this.token);
      if (this.token != null) {
        const tokenDecoded = this._jwtHelperService.decodeToken(this.token);
        this.loginUser.next(new UserModel(tokenDecoded.id, tokenDecoded.rlnm.split(',').map((x: string) => +x)))
        this._isManager$.next(tokenDecoded.rlnm.includes(RoleNameEnum.PosManager));
        this._isAdmin$.next(tokenDecoded.rlnm.includes(RoleNameEnum.PosGeneralManager));
      }
    } else if (this.waiterToken && !_jwtHelperService.isTokenExpired(this.waiterToken)){
      this._isLoggedIn$.next(!!this.waiterToken);
      if (this.waiterToken != null) {
        const tokenDecoded = this._jwtHelperService.decodeToken(this.waiterToken);
        this.loginUser.next(new UserModel(tokenDecoded.id, tokenDecoded.rlnm.split(',').map((x: string) => +x)))
      }
    }else {
      this.loginUser.next(null);
    }
  }
  //#region Public Methods
  login(model: LoginModel) {
    var url = AUTH_API + "authenticate";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  waiterLogin(model: WaiterLoginModel){
    var url = WTR_USER_API + "authenticate";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  confirmPassword(model: ResetPasswordModel) {
    var url = AUTH_API + "confirmpassword";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  forgotPassword(model: ForgotPasswordModel) {
    var url = AUTH_API + "forgotpassword";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  signup(model: SignupModel) {
    var url = GMN_USER_API + "register";
    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }
  logout() {
    var url = AUTH_API + "signout";
    return this._httpService.httpPost(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  logoutWaiter() {
    var url = WTR_USER_API + "signout";
    const model: SignoutModel = new SignoutModel();
    model.token = localStorage.getItem("waiter_refresh_token") as string;
    return this._waiterHttpService.httpPost(url,model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  getallcountrynames() {
    var url = GMN_USER_API + "getallcountrynames";
    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }


  getProfile(roles?: Array<RoleNameEnum>) {
    let url = roles?.includes(RoleNameEnum.PosGeneralManager) ? GMN_USER_API : MNG_USER_API;
    url += 'getuserprofile';

    return this._httpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  getWaiterProfile() {
    var url = WTR_USER_API + "getuserprofile";
    return this._waiterHttpService.httpGet(url)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updateProfile(model: EditProfileModel, roles?: Array<RoleNameEnum>) {
    let url = roles?.includes(RoleNameEnum.PosGeneralManager) ? GMN_USER_API : MNG_USER_API;
    url += 'updateuserpofile';

    return this._httpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  updatWaitereProfile(model: EditProfileModel) {
    let url = WTR_USER_API + 'updateuserpofile';

    return this._waiterHttpService.httpPost(url, model)
      .pipe(map(resposne => {
        return resposne;
      }));
  }

  uploadProfilePicture(file: any, roles?: Array<RoleNameEnum>) {
    let url = roles?.includes(RoleNameEnum.PosGeneralManager) ? GMN_USER_API : MNG_USER_API;
    url += 'uploadprofilepicture';

    const formData: FormData = new FormData();
    formData.append('File', file as string);
    return this._httpClient
      .post<any>(url, formData, {
        headers: new HttpHeaders().set('Authorization', `Bearer ${localStorage.getItem("pos_access_token") as string}`)
      })
      .pipe(map(response => {
        return response;
      }));
  }

  getCompanyId() {
    if (this.token != null) {
      let tokenDecoded = this._jwtHelperService.decodeToken(this.token);
      return tokenDecoded.cmid;
    }
  }

  changePasswordManually(model: ChangePasswordModel) {
    let url = AUTH_API + "changepassword";
    return this._httpService.httpPost(url, model)
      .pipe(map(response => {
        return response;
      }));
  }

  refreshToken(refreshToken: RefreshTokenModel){
    let url = AUTH_API + "refresh-token";
    return this._httpService.httpPost(url, refreshToken)
      .pipe(map(response => {
        return response;
      }));
  }

}
